import React, { FunctionComponent, ReactElement, RefObject } from 'react'
import Touchable from '@sport1/react-elements/Touchable'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { TestID } from '../../utils/PropTypesDefinitions'
import BodyFont from '../../Theme/Fonts/Body'
import LinkProps from '../../Link/LinkProps'

export type LinkTeaserProps = {
    /** text to display */
    text: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * function that will be called when the teaser is clicked
     *
     * @TJS-type function
     *
     */
    onPress: () => void
    children?: never
    /**
     * property for ref forwarding
     * @TJS-type React.RefObject<Element>
     * */
    innerRef?: RefObject<Element>
} & LinkProps &
    TestID

const LinkTeaser: FunctionComponent<LinkTeaserProps> = ({
    text,
    href,
    onPress,
    innerRef,
    testID,
    webRel,
}): ReactElement => {
    return (
        <Touchable
            onPress={onPress}
            href={href}
            activeOpacity={0.8}
            testID={testID}
            webRel={webRel}
        >
            <Grid
                ref={innerRef}
                noExpand
                horizontal
                centerVertical
                backgroundColor="pearl"
                paddingX={5}
                paddingY={3}
                borderRadius={4}
                border={1}
                borderColor="moon-3"
            >
                <Grid marginRight={5}>
                    <BodyFont color="onyx">{text}</BodyFont>
                </Grid>
                <FontelloIcon name="scroll-right" fontSize={15} color="onyx" textAlign="center" />
            </Grid>
        </Touchable>
    )
}

export default LinkTeaser
